import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { WorkspacePrebidConfigurationDTO } from 'features/globalSetup/api/types/workspacePrebidConfiguration'
import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'
import { floatPercentFromDTO } from 'utils/number'

type From = WorkspacePrebidConfigurationDTO
type To = WorkspacePrebidConfiguration

export const fromDTO = (from: From): To =>
  mapDTO<From, WorkspacePrebidConfiguration>({ from }).transform(
    (workspacePrebidConfiguration: From): To => {
      const {
        allowActivitiesData,
        disablePrebidStackForUsersWithPoorInternetEnabled,
        maximumRttToEnablePrebidStack,
        prebidCustomConfig,
        prebidVariableName,
        s2sTimeoutMultiplier,
      } = workspacePrebidConfiguration

      return {
        ...workspacePrebidConfiguration,
        allowActivitiesData: allowActivitiesData ?? '',
        connectionSpeed: {
          disablePrebidStack: disablePrebidStackForUsersWithPoorInternetEnabled,
          maxRtt: maximumRttToEnablePrebidStack,
        },
        prebidCustomConfig: JSON.stringify(prebidCustomConfig, null, JSON_SPACE),
        prebidVariableName: prebidVariableName ?? undefined,
        s2sTimeoutMultiplier: floatPercentFromDTO(s2sTimeoutMultiplier),
      }
    },
  )
